module.exports = __webpack_public_path__ + "assets/ic-www.bf57f4c2.svg";